<div class="page-header"><h1 class="page-title">Agent Provision</h1></div>
<div class="container">
	<form [formGroup]="agentForm" (ngSubmit)="submit()" class="p-4 space-y-4">
		<div *ngIf="data">
			<div class="row">
				<div class="col-6">
					<div class="card">
						<div class="card-header">Inputs</div>
						<div class="card-body">
							<div class="form-floating mb-3">
								<input type="text" id="inputUsername" formControlName="username" class="form-control">
								<label for="inputUsername">Username</label>
								<div *ngIf="controlInvalid('username')" class="text-danger">{{ getError('username') }}</div>
							</div>
							<div class="form-floating mb-3">
								<input type="email" id="inputEmail" formControlName="email" class="form-control">
								<label for="inputEmail">Email</label>
								<div *ngIf="controlInvalid('email')" class="text-danger">{{ getError('email') }}</div>
							</div>
							<div class="form-floating mb-3">
								<input type="tel" id="inputMsisdn" formControlName="msisdn" class="form-control"
									placeholder="e.g. 27821234567">
								<label for="inputMsisdn">MSISDN</label>
								<div *ngIf="controlInvalid('msisdn')" class="text-danger">{{ getError('msisdn') }}</div>
							</div>
							<div class="form-floating mb-3">
								<select formControlName="partner" id="inputPartner" class="form-control">
									<option value="">Select a partner</option>
									<option *ngFor="let partner of data.partners" [ngValue]="partner">{{ partner.name }}</option>
								</select>
								<label for="inputPartner">Partner</label>
								<div *ngIf="controlInvalid('partner')" class="text-danger">{{ getError('partner') }}</div>
							</div>
							<div class="form-floating mb-3">
								<select formControlName="role" id="inputRole" class="form-control">
									<option value="">Select role</option>
									<option *ngFor="let role of data.roles" [ngValue]="role">{{ role.name }}</option>
								</select>
								<label for="inputRole">Role</label>
								<div *ngIf="controlInvalid('role')" class="text-danger">{{ getError('role') }}</div>
							</div>
							<div class="form-floating mb-3">
								<input type="text" id="inputIdNumber" formControlName="idNumber" class="form-control">
								<label for="inputIdNumber">ID Number/ Passport Number</label>
								<div *ngIf="isIdNumberInvalid" class="text-danger">{{ idNumberError }}</div>
							</div>
							<button type="submit" class="btn btn-primary" [disabled]="isFormInvalid()">Provision Agent</button>
						</div>
					</div>
				</div>
				<div class="col-6">
					<div class="card">
						<div class="card-header">Government Data <small>(readonly)</small></div>
						<div class="card-body" *ngIf="loading == true">
							Loading...
						</div>
						<ng-container *ngIf="loading == false">
							<div class="card-body" *ngIf="!governmentRecordResult">
								Waiting for Document Number, Serial Number or ID Number.
							</div>
							<div class="card-body" *ngIf="governmentRecordResult && !governmentRecordResult.governmentRecord">
								No Government record found.
							</div>
							<div class="card-body" *ngIf="governmentRecordResult && governmentRecordResult.duplicate == true">
								Document already used.
							</div>
							<div class="card-body" *ngIf="governmentRecordResult && governmentRecordResult.governmentRecord && governmentRecordResult.duplicate == false">
								<div class="alert alert-danger" *ngIf="governmentRecordResult.errorMessage">
									{{governmentRecordResult.errorMessage}}
								</div>
								<div class="row mb-1">
									<label class="col-sm-4 col-form-label" for="documentType">Document Type</label>
									<div class="col-sm-8">
										<input type="text" id="documentType" class="form-control form-control-sm" placeholder="Document Type" name="documentType" [value]="governmentRecordResult.governmentRecord.documentType" readonly>
									</div>
								</div>
								<div class="row mb-1">
									<label class="col-sm-4 col-form-label" for="documentNumber">Document Number</label>
									<div class="col-sm-8">
										<input type="text" id="documentNumber" class="form-control form-control-sm" placeholder="Document Number" name="documentNumber" [value]="governmentRecordResult.governmentRecord.documentNumber" readonly>
									</div>
								</div>
								<div class="row mb-1">
									<label class="col-sm-4 col-form-label" for="idNumber">ID Number</label>
									<div class="col-sm-8">
										<input type="text" id="idNumber" class="form-control form-control-sm" placeholder="ID Number" name="idNumber" [value]="governmentRecordResult.governmentRecord.idNumber" readonly>
									</div>
								</div>
								<div class="row mb-1">
									<label class="col-sm-4 col-form-label" for="firstName">First Name</label>
									<div class="col-sm-8">
										<input type="text" id="firstName" class="form-control form-control-sm" placeholder="First Name" name="firstName" [value]="governmentRecordResult.governmentRecord.firstName" readonly>
									</div>
								</div>

								<div class="row mb-1" *ngIf="governmentRecordResult.governmentRecord.otherName">
									<label class="col-sm-4 col-form-label" for="otherNames">Other Names</label>
									<div class="col-sm-8">
										<input type="text" id="otherNames" class="form-control form-control-sm" placeholder="Other Name" name="otherNames" [value]="governmentRecordResult.governmentRecord.otherName" readonly>
									</div>
								</div>
								<div class="row mb-1">
									<label class="col-sm-4 col-form-label" for="lastName">Last Name</label>
									<div class="col-sm-8">
										<input type="text" id="lastName" class="form-control form-control-sm" placeholder="Last Name" name="lastName" [value]="governmentRecordResult.governmentRecord.surname" readonly>
									</div>
								</div>
								<div class="row mb-1">
									<label class="col-sm-4 col-form-label" for="family">Family</label>
									<div class="col-sm-8">
										<input type="text" id="family" class="form-control form-control-sm" placeholder="Family" name="family" [value]="governmentRecordResult.governmentRecord.family" readonly>
									</div>
								</div>

								<div class="row mb-1">
									<label class="col-sm-4 col-form-label" for="gender">Gender</label>
									<div class="col-sm-8">
										<input type="text" id="gender" class="form-control form-control-sm" placeholder="Gender" name="gender" [value]="governmentRecordResult.governmentRecord.gender" readonly>
									</div>
								</div>
								<div class="row mb-1">
									<label class="col-sm-4 col-form-label" for="dateOfBirth">Date of Birth</label>
									<div class="col-sm-8">
										<input type="text" id="dateOfBirth" class="form-control form-control-sm" placeholder="Date of Birth" name="dateOfBirth" [value]="governmentRecordResult.governmentRecord.dateOfBirth" readonly>
									</div>
								</div>
								<div class="row mb-1">
									<label class="col-sm-4 col-form-label" for="dateOfIssue">Date of Issue</label>
									<div class="col-sm-8">
										<input type="text" id="dateOfIssue" class="form-control form-control-sm" placeholder="Date of Issue" name="dateOfIssue" [value]="governmentRecordResult.governmentRecord.dateOfIssue" readonly>
									</div>
								</div>
								<div class="row mb-1">
									<label class="col-sm-4 col-form-label" for="dateOfExpiry">Date of Expiry</label>
									<div class="col-sm-8">
										<input type="text" id="dateOfExpiry" class="form-control form-control-sm" placeholder="Date of Expiry" name="dateOfExpiry" [value]="governmentRecordResult.governmentRecord.dateOfExpiry" readonly>
									</div>
								</div>
								<div class="row mb-1">
									<label class="col-sm-4 col-form-label" for="citizenship">Citizenship</label>
									<div class="col-sm-8">
										<input type="text" id="citizenship" class="form-control form-control-sm" placeholder="Citizenship" name="Citizenship" [value]="governmentRecordResult.governmentRecord.citizenship" readonly>
									</div>
								</div>
								<div class="row mb-1">
									<label class="col-sm-4 col-form-label" for="occupation">Occupation</label>
									<div class="col-sm-8">
										<input type="text" id="occupation" class="form-control form-control-sm" placeholder="Occupation" name="Occupation" [value]="governmentRecordResult.governmentRecord.occupation" readonly>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
			<!--
			<ul *ngIf="errorsList.length > 0">
				<li *ngFor="let err of errorsList">
					[{{ err.field }}]: [{{ err.errors | json }}]
				</li>
			</ul>
			-->
		</div>
	</form>
</div>
